module.exports = __webpack_public_path__ + "img/support2.c591974.svg";